import { BackgroundAction } from '../BackgroundAction'
import { bankTransactionsBackgroundAction, paymentTransactionsBackgroundAction } from './api'

export const BankTransactionsExportBackgroundAction = new BackgroundAction({
  api: bankTransactionsBackgroundAction,
})

export const PaymentTransactionsExportBackgroundAction = new BackgroundAction({
  api: paymentTransactionsBackgroundAction,
})
